import store from '@/store'

export default (to, from, next) => {
  if (store.getters['wAuth/isLoggedIn']) {
    return next(false)
  }
  return next()
}